import { expected, isNil } from '@aloft/toolkit-shared';

import { useNavigate, useParams } from 'react-router';

import { useTkv2Order } from '../hooks/useTkv2Order.ts';
import { CraftsmanOrderRootElement } from './CraftsmanOrderRootElement.tsx';
import { Tkv2OrderRootRouteElement } from './Tkv2OrderRootElement.tsx';

export const OrderRootElement = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const orderID = expected(orderId);
  const order = useTkv2Order({ pathParams: { orderID } }, { meta: { showGlobalLoader: true } });
  if (isNil(order.data)) return null;

  if (order.data.isCompleted) {
    navigate('/orders', { replace: true });
    return null;
  }

  if (order.data.input.version === 2) return <CraftsmanOrderRootElement />;

  // still needed for legacy export
  return <Tkv2OrderRootRouteElement />;
};
